/**
 * Download a URL as a file without navigating to it: fetch the bytes as a blob so a credentialed
 * (presigned) URL never enters the address bar, history, or referrer, then save via a transient
 * anchor. The deferred revoke avoids a race where revoking synchronously after click() cancels the
 * download in some browsers.
 */
export async function downloadUrlAsFile(url: string, filename: string): Promise<void> {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`)
  }
  const objectUrl = URL.createObjectURL(await response.blob())
  const anchor = document.createElement("a")
  anchor.href = objectUrl
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
}
